import Confirmtemplate from './confirm.vue'

function defaultCallBack (action){
    if(!action) currentMsg.reject()
    currentMsg.resolve()
}

let Confirm = {}
let currentMsg = null

Confirm.install = function(Vue,options={}){
    
    const VueConfirm = Vue.extend(Confirmtemplate)  //创建模板
    
    let confirm;
    VueConfirm.prototype.callBack = defaultCallBack

    Vue.prototype.$confirm = (params) =>{
        
        // confirm = null;
        // 此处可优化，遮罩层应该永远只有一层; 且不应该闪烁。
        if(confirm) confirm.$destroy();
        
        confirm = new VueConfirm().$mount()  //创建实例
        document.body.appendChild(confirm.$el)  //挂载实例
        
        confirm.show(params)
        
        return new Promise((resolve,reject) => {
            currentMsg = {resolve,reject}
        })
    }
}


export default Confirm